import { createUrl, formatSecondsToTime, stringfyArrayItems } from 'app/utils';
import formatDateFromUtcToTimezone from 'app/utils/formatDateFromUtcToTimezone';
import { IconsTypes } from 'components/icons';
import moment from 'moment';

import { StudentPracticeExamAssessmentStatusEnum, ExamsItem } from 'features/exams';
import { CardSearchProps } from './ExamsCard';

type CardObject = Omit<CardSearchProps, 'view'>;

export const factoryCardSearch = (exam: ExamsItem): CardObject => {
  const title = exam.name ?? '';
  const titleLabel = `${exam.questionCount} QUESTÕES`;
  const titleColor = 'white';

  const subtitle = exam.productName ?? ''; // TODO: Adicionar nome do produto
  const subtitleColor = 'white';

  let buttonLabelToBeRelease = '';

  let subtitleLabel = '';
  let releaseDate = '';
  if (exam.releaseDate) {
    const releaseAt = formatDateFromUtcToTimezone(exam.releaseDate);

    releaseDate = releaseAt.format('DD/MM HH[h]mm');
    buttonLabelToBeRelease = `${releaseAt.format('DD[/]MM[/]YYYY HH[h]mm')}`;

    subtitleLabel += `${releaseDate}`;
  }

  let closeDate = '';
  if (exam.closeDate) {
    closeDate = formatDateFromUtcToTimezone(exam.closeDate).format('DD/MM HH[h]mm');
    subtitleLabel += ` ATÉ ${closeDate}`;
  }

  let duration = exam.durationSeconds ? formatSecondsToTime(exam.durationSeconds) : '';
  if (duration) {
    subtitleLabel += `${!!(releaseDate || closeDate) ? ' • ' : ''}${duration}`;
  }

  const unavailableMessageHeader = 'Disponível para:';
  const unavailableMessage = stringfyArrayItems(exam.allowedCourses); // TODO: Adicionar produtos que podem acessar
  const showOverlay = false;

  let buttonLabel = 'Não especificado';
  const buttonColor = 'white';

  const buttonIcon = 'arrowRight';
  const buttonIconColor = 'white';
  const buttonBackground = 'secondary_300';

  const link = createUrl('exams/start', [exam.uuid]);
  const background = 'white';

  const cardsDefault: CardObject = {
    title,
    titleLabel,
    titleColor,

    subtitle,
    subtitleLabel,
    subtitleColor,

    buttonLabel,
    buttonColor,

    buttonIcon,
    buttonIconColor,
    // buttonIconColorHover,

    buttonBackground,
    // buttonBackgroundHover,

    link,

    background,
    // backgroundHover,

    showOverlay,
    unavailableMessageHeader,
    unavailableMessage,
  };

  const cardsBlue: CardObject = {
    ...cardsDefault,
    background: 'secondary_400',
    buttonBackgroundHover: 'secondary_300',
  };

  const cardsGray: CardObject = {
    ...cardsDefault,
    background: 'gray_600',
    buttonBackground: 'gray_600',
    buttonBackgroundHover: 'gray_600',
    buttonIcon: 'lock' as IconsTypes,
    titleColor: 'gray_500',
    subtitleColor: 'gray_500',
  };

  if (exam.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.Unspecified) {
    //0
  }

  if (exam.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.AvailableToBuy) {
    //1
    return {
      ...cardsDefault,
      buttonLabel: 'ADQUIRIR',
      background: 'dark_350',
    };
  }

  if (exam.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.ToBeReleased) {
    //2
    return {
      ...cardsDefault,

      buttonLabel: buttonLabelToBeRelease || 'INDISPONIVEL',
      buttonColor: 'white',
      buttonIcon: buttonLabelToBeRelease ? undefined : 'lock',

      background: 'dark_350',
      backgroundHover: 'dark_150',
      buttonBackground: 'white25',
      cursor: 'not-allowed',
      link: undefined,
    };
  }

  if (exam.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.ReleasedNotStarted) {
    //3
    return {
      ...cardsBlue,
      buttonLabel: 'INICIAR',
      buttonBackgroundHover: 'secondary_300',
    };
  }

  if (exam.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.StartedNotFinished) {
    //4
    return {
      ...cardsBlue,
      buttonLabel: 'CONTINUAR',
    };
  }

  if (exam.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.Finished) {
    //5

    if (exam?.studentPracticeExamAssessment) {
      const startDate = moment(exam?.assessmentStartDate);
      const finalizeDate = moment(exam?.assessmentFinalizeDate);

      return {
        ...cardsBlue,
        subtitle: `Realizada: ${formatDateFromUtcToTimezone(exam?.assessmentFinalizeDate).format('DD/MM/YYYY')}`,
        subtitleLabel: `Duração: ${formatSecondsToTime(finalizeDate.diff(startDate, 'seconds'))}`,
        buttonLabel: 'VER RESULTADO',
        link: createUrl('exams/result', [exam.uuid, exam?.studentPracticeExamAssessment]),
      };
    }
  }

  if (exam.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.NotDone) {
    //6
    return {
      ...cardsGray,
      buttonLabel: 'NÃO REALIZADA',
      background: 'gray_600',
      link: undefined,
      cursor: 'not-allowed',
    };
  }

  if (exam.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.Unavailabled) {
    //7
    return {
      ...cardsGray,
      buttonLabel: 'INDISPONÍVEL',
      showOverlay: !!exam.allowedCourses.length,
      unavailableMessage,
      link: undefined,
      cursor: 'not-allowed',
    };
  }

  if (exam.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.Blocked) {
    //8
    return {
      ...cardsGray,
      buttonLabel: 'BLOQUEADO',
      cursor: 'not-allowed',
    };
  }

  return cardsDefault;

  //
  // const buttonLabelToBeRelease = `LIBERA EM: ${formatDate(exam.releaseDate).format('DD[/]MM[/]YYYY')}`;
  // const buttonLabelReleased = `REALIZADA: ${formatDate(exam.releaseDate).format('DD[/]MM[/]YYYY')}`;

  // const link = exam.uuid ? createUrl('exams/start', [exam.uuid]) : '';

  // const cardsDefault = {
  // title,
  // subtitle,
  // subtitleLabel,
  // titleLabel,
  // buttonIcon: 'arrowRight' as IconsTypes,
  // buttonIconColor: 'white' as ColorsTypes,
  // buttonBackground: 'secondary_300' as ColorsTypes,
  // buttonColor: 'white' as ColorsTypes,
  // hoverButtonBackground: 'secondary_600' as ColorsTypes,
  // color: 'white' as ColorsTypes,
  // colorSubtitle: 'white' as ColorsTypes,
  // cursor: 'pointer' as IconsTypes,
  // data: exam,
  // link,
  // };

  // const cardsBlue = {
  //   ...cardsDefault,
  //   background: 'secondary_400' as ColorsTypes,
  // };

  // const cardsGray = {
  //   ...cardsDefault,
  //   background: 'gray_600' as ColorsTypes,
  //   buttonBackground: 'gray_600' as ColorsTypes,
  //   hoverButtonBackground: 'gray_600' as ColorsTypes,
  //   buttonIcon: 'lock' as IconsTypes,
  //   color: 'gray_500' as ColorsTypes,
  //   colorSubtitle: 'gray_500' as ColorsTypes,
  // };

  // if (exam.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.ToBeReleased)
  //   return {
  //     ...cardsDefault,
  //     buttonLabel: buttonLabelToBeRelease,
  //     background: 'dark_350',
  //     buttonBackground: 'white25',
  //     hoverButtonBackground: 'white25',
  //     cursor: 'not-allowed',
  //   };

  // if (exam.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.ReleasedNotStarted)
  //   return {
  //     ...cardsBlue,
  //     buttonLabel: 'INICIAR',
  //   };

  // if (exam.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.StartedNotFinished)
  //   return {
  //     ...cardsBlue,
  //     buttonLabel: 'CONTINUAR',
  //     link: createUrl('exams/assessment', [exam.uuid, exam.studentPracticeExamAssessment]),
  //   };

  // if (exam.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.Finished)
  //   return {
  //     ...cardsBlue,
  //     buttonLabel: buttonLabelReleased,
  //   };

  // if (exam.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.NotDone)
  //   return {
  //     ...cardsBlue,
  //     buttonLabel: 'NÃO REALIZADA',
  //     background: 'gray_600',
  //   };

  // if (exam.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.Unavailabled)
  //   return {
  //     ...cardsGray,
  //     buttonLabel: 'INDISPONÍVEL',
  //     showOverlay: true,
  //     unavailableMessage,
  //   };

  // if (exam.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.Blocked)
  //   return {
  //     ...cardsGray,
  //     buttonLabel: 'BLOQUEADO',
  //     cursor: 'not-allowed',
  //   };

  // return {
  //   title: title,
  //   buttonLabel: 'Não especificado',
  //   subtitle: subtitle,
  //   subtitleLabel: subtitleLabel,
  //   titleLabel: titleLabel,
  //   color: 'dark_350',
  //   borderColor: 'gray_300',
  // };
};
